__turbopack_context__.v({
  "backInStock": "AddToCartButton-module__s5Dv1q__backInStock",
  "backInStockContent": "AddToCartButton-module__s5Dv1q__backInStockContent",
  "close": "AddToCartButton-module__s5Dv1q__close",
  "error": "AddToCartButton-module__s5Dv1q__error",
  "preorder": "AddToCartButton-module__s5Dv1q__preorder",
  "success": "AddToCartButton-module__s5Dv1q__success",
});
